import React from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import { createUseStyles } from "react-jss";
import { useTranslation } from "react-i18next";
import ReportDatePicker from "components/ReportDatePicker";
import YieldHistory from "./components/YieldHistory";
import AllocationHistory from "./components/AllocationHistory";
import YieldList from "./components/YieldList";
import YieldPerTimespan from "./components/YieldPerTimespan";
import Distributions from "./components/Distributions";
import SummaryList from "./components/SummaryList";
import AssetClassDistributionList from "./components/AssetClassDistributionList";

const useStyles = createUseStyles({
  container: {
    padding: "1em 0",
  },
});

const Overview = () => {
  const classes = useStyles();

  const matchesMediaQuery = useMediaQuery("(min-width: 960px)");

  const { t } = useTranslation();

  return (
    <Grid container justifyContent="center">
      <Grid item container md={10} sm={12} justifyContent="space-between">
        {matchesMediaQuery ? (
          <Grid item xs={6} md={5}>
            <h1 style={{ color: "#003366" }}>{t("overview")}</h1>
          </Grid>
        ) : (
          <></>
        )}
        <Grid
          container
          item
          md={2}
          sm={12}
          alignContent="center"
          justifyContent="flex-start"
        >
          <ReportDatePicker />
        </Grid>
      </Grid>
      <Grid
        className={classes.container}
        flexWrap={matchesMediaQuery ? "wrap" : "nowrap"}
        container
        item
        md={10}
        sm={12}
        flexDirection={matchesMediaQuery ? "row" : "column"}
      >
        <YieldHistory />
        <AllocationHistory />
      </Grid>
      <Grid
        container
        item
        md={10}
        sm={12}
        justifyContent="flex-start"
        style={{ paddingTop: 0 }}
      >
        <h3 style={{ color: "#444443", margin: 0 }}>{t("profit")}</h3>
      </Grid>
      <Grid
        className={classes.container}
        container
        item
        md={10}
        sm={12}
        style={{
          width: matchesMediaQuery ? "100%" : "calc(100% + 32px)",
          maxWidth: matchesMediaQuery ? "100%" : "calc(100% + 32px)",
        }}
      >
        <YieldList />
        <YieldPerTimespan />
      </Grid>
      <Grid container item md={10} sm={12} justifyContent="flex-start">
        <h3 style={{ color: "#444443", margin: 0 }}>{t("current")}</h3>
      </Grid>
      <Grid
        className={classes.container}
        container
        item
        md={10}
        sm={12}
        flexDirection={matchesMediaQuery ? "row" : "column"}
      >
        <Distributions />
      </Grid>
      <Grid
        container
        item
        md={10}
        sm={12}
        justifyContent="flex-start"
        style={{ paddingTop: 0 }}
      >
        <h3 style={{ color: "#444443", margin: 0 }}>{t("profit")}</h3>
      </Grid>
      <Grid
        className={classes.container}
        container
        item
        md={10}
        sm={12}
        style={{
          maxWidth: matchesMediaQuery ? "100%" : "calc(100% + 32px)",
          width: matchesMediaQuery ? "100%" : "calc(100% + 32px)",
        }}
      >
        <SummaryList />
        <AssetClassDistributionList />
      </Grid>
    </Grid>
  );
};

export default React.memo(Overview);
